import React from 'react'

export default function A2HSPrompt() {
  const [deferredEvt, setDeferredEvt] = React.useState(null)
  const [visible, setVisible] = React.useState(false)

  React.useEffect(() => {
    const onBeforeInstall = (e) => {
      // Prevent the mini-infobar on mobile
      e.preventDefault()
      setDeferredEvt(e)
      setVisible(true)
    }
    window.addEventListener('beforeinstallprompt', onBeforeInstall)
    return () => window.removeEventListener('beforeinstallprompt', onBeforeInstall)
  }, [])

  if (!visible) return null

  return (
    <div className="fixed inset-x-2 bottom-[max(env(safe-area-inset-bottom),1rem)] z-[60] flex justify-center">
      <div className="max-w-sm w-full bg-white shadow-xl border border-gray-200 rounded-xl p-3 flex items-center gap-3">
        <div className="flex-1">
          <div className="text-sm font-medium">Install PPAC App</div>
          <div className="text-xs text-ink/60">Get faster access and offline support.</div>
        </div>
        <div className="flex items-center gap-2">
          <button
            className="text-xs px-2 py-1 rounded hover:bg-gray-100"
            onClick={() => setVisible(false)}
          >
            Not now
          </button>
          <button
            className="text-xs px-3 py-1.5 rounded bg-brand-600 text-white hover:bg-brand-700"
            onClick={async () => {
              if (!deferredEvt) return
              deferredEvt.prompt()
              const { outcome } = await deferredEvt.userChoice
              // Hide regardless of choice; browser may re-fire later if dismissed
              setVisible(false)
              setDeferredEvt(null)
            }}
          >
            Install
          </button>
        </div>
      </div>
    </div>
  )
}
